import {ApiFilter, AppResourceSearch} from '@sellers-shield-home-protection/ss-core-js';
import OrderAppResource from '@sellers-shield-home-protection/ss-core-js/src/AppResources/OrderAppResource';
import {paramsFromQueryString} from "@helpers/router-helper";
import UserMixin from '@mixins/UserMixin';
export default {

    data: () => ({
        loading: false,
        orderAppResourceUuid: null,
        referringPlatformUuid: null,
        agentOwnsOrder: true
    }),
    mixins:[
        UserMixin
    ],
    methods: {
        async fetchReferringPlatform(){

            let appResource = null;
            let params = paramsFromQueryString(this.$route.query);

            const referringPlatformSearch = new AppResourceSearch('referring-platform');
            
            await referringPlatformSearch.setSearchData({
                pageSize: 'disabled',
                filter: new ApiFilter({
                    params: {
                        'slug': params.referringPlatform
                    }
                })
            }, false);
            await referringPlatformSearch.search();

            if(!referringPlatformSearch.appResourceCollection.isEmpty){
                appResource = (referringPlatformSearch.appResourceCollection.getFirst() || {});
            }

            if (appResource) {
                this.referringPlatformUuid = appResource.uuid;
            }
        },
        async fetchOrder(externalId) {
            let appResource = null;
            if(!this.referringPlatformUuid){
                return;
            }

            this.agentOwnsOrder = true;
            
            if(!!externalId){
                const appResourceSearch = new AppResourceSearch('third-party-integration');
                await appResourceSearch.setSearchData({
                    pageSize: 1,
                    andOr: 'and',
                    filter: new ApiFilter({
                        andOr:'and',
                        params: {
                            externalId: externalId,
                            platformUuid: this.referringPlatformUuid,
                        }
                    }),
                    include: ['pivots']
                }, false);
    
                await appResourceSearch.search();
                if (!appResourceSearch.appResourceCollection.isEmpty) {
                    
                    appResource = (
                        (appResourceSearch.appResourceCollection.getFirst() || {}).pivots?.toArray() || []
                    ).find(
                        objResource => objResource?.modelType === 'order' && Boolean(objResource.modelUuid)
                    );
                }
            }

            //Validate if Agent has access to view Disclosure and if not where to redirect to
            if (appResource && appResource.modelUuid) {
                const orderAppResourceSearch = new OrderAppResource({uuid: appResource.modelUuid});
                await orderAppResourceSearch.find(['agent']);
                if(orderAppResourceSearch.agent.uuid !== this.me.uuid){
                    this.agentOwnsOrder = false;
                }
                this.orderAppResourceUuid = appResource.modelUuid;
            }
        },

        async getParamsAndCheckExistence() {
            let params = paramsFromQueryString(this.$route.query),
                developerListingId = this.$route.params.developerListingId;

            params.developerListingId = params.developerListingId || developerListingId;

            await this.catchAppResourceErrors(async () => {
                await this.fetchReferringPlatform();
                await this.fetchOrder(params.developerListingId);
            }, 'loading');

            delete params.accessToken;
            delete params.authCallbackUrl;

            return params;
        }
    },
};
